import { Spin } from "antd";
import { inject, observer } from "mobx-react";

import InfiniteScroll from "react-infinite-scroller";
import React from "react";
import _ from "lodash";
import moment from "moment";

@inject("store")
@observer
class UserDeleted extends React.Component {
  loadMoreDeletedMessages = () => {
    const {
      store: {
        DeletedMessagesStore: { userDeletedLoading, fetchUserDeletedMessages },
        ProfileStore: { userId },
      },
    } = this.props;
    if (userDeletedLoading) {
      return;
    }
    fetchUserDeletedMessages(userId);
  };

  render() {
    const {
      store: {
        DeletedMessagesStore: {
          userDeletedMessages,
          userDeletedLoading,
          groupNames,
          dmNames,
          userDeletedSkip,
          userDeletedTotal,
        },
      },
    } = this.props;
    return userDeletedMessages.length ? (
      <div className="group-chat">
        <div style={{ height: "calc(100vh - 275px)", overflow: "auto" }}>
          <InfiniteScroll
            loadMore={this.loadMoreDeletedMessages}
            useWindow={false}
            hasMore={userDeletedSkip < userDeletedTotal}
          >
            {userDeletedMessages.map((message, index) => {
              return message.userId ? (
                <div key={message.messageId}>
                  <div className="flag-container">
                    <div className="flag-upper">
                      <div className="flag-name-container">
                        <div>
                          <span className="flag-name">{message.sender}</span>
                        </div>
                      </div>
                      <div className="flag-time">
                        {moment(message.createdAt).calendar()}
                      </div>
                    </div>
                    {message.channelType === "GROUP" ? (
                      <div className="info-icon-container">
                        <div className="flag-group">
                          {`in ${groupNames.get(message.channelId)}`}
                        </div>
                      </div>
                    ) : null}
                    {message.channelType === "DIRECT" ? (
                      <div className="info-icon-container">
                        <div className="flag-group">
                          {`in ${dmNames.get(message.channelId)}`}
                        </div>
                      </div>
                    ) : null}
                    <div className="flag-middle">
                      {message.type === "text" ? (
                        <div className="flag-message-container">
                          <div className="heading">{message.text}</div>
                        </div>
                      ) : message.type === "img" || message.type === "gif" ? (
                        <img
                          src={message.imgUrl}
                          alt=""
                          height="60"
                          width="60"
                        />
                      ) : (
                        <span className="heading"></span>
                      )}
                      <br />

                      <span className="subHeading">
                        {`Deleted by ${message.deletedBy}`}
                      </span>
                    </div>
                  </div>
                  <hr className="horizontal-tag" />
                </div>
              ) : null;
            })}
            {userDeletedLoading && (
              <div className="loading-alert-members">
                <Spin />
              </div>
            )}
          </InfiniteScroll>
        </div>
      </div>
    ) : userDeletedLoading ? (
      <div className="loading-alert-members">
        <Spin />
      </div>
    ) : null;
  }
}
export default UserDeleted;
